export default {
  link: 'http://pomnimvseh.histrf.ru/',
  previewSrc: 'nation-archive_1-min.png',
  title: 'Народный архив 1914 – 1918',
  announce:
    'Интернет-сервис «ВЕЛИКАЯ ВОЙНА» предлагает любому участнику проекта на на добровольной основе создать собственную страницу об участии его родственников в Первой мировой войне. Таким образом, будет формироваться социальная сеть людей, неравнодушных к собственной истории, к истории своей семьи. А документы и фотографии периода Первой мировой войны не будут утеряны безвозвратно.',
  model_type: 'specialprojectsection',
  type: 'second',
  gallery: [
    {
      static: 'nation-archive',
      previewSrc: '582e63921f3773e65f0a0e9d4422842c.jpg',
      link: 'http://pomnimvseh.histrf.ru/14photos/detail.php?ID=19671',
      title: '',
    },
    {
      static: 'nation-archive',
      previewSrc: '32dda8395256c1c46dd28ab00a062d3b.jpg',
      link: 'http://pomnimvseh.histrf.ru/14photos/detail.php?ID=19670',
      title: '',
    },
    {
      static: 'nation-archive',
      previewSrc: 'e6e6be88ca197865f58de5d8ffebfb41.jpg',
      link: 'http://pomnimvseh.histrf.ru/14photos/detail.php?ID=19680',
      title: '',
    },
    {
      static: 'nation-archive',
      previewSrc: '9598c1591510feba446532fdcb814ae3.jpg',
      link: 'http://pomnimvseh.histrf.ru/14photos/detail.php?ID=19618',
      title: '',
    },
  ],
};
